/* ============
 * * Packaging Type Module Mutations
 * ============
 */

import { FETCH_UNIT_TYPES } from '../../mutation-types';

export default {
  [FETCH_UNIT_TYPES](state, unitTypes) {
    state.all = unitTypes;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/unitType/mutations.js